import { TLegalList } from 'shared/types/legalPages.interface';

export const CommunityGuidelinesLists: TLegalList = {
  RespectfulConduct: [
    {
      description: 'Debate the ideas, not the person.',
    },
    {
      description: 'No harassment, bullying, or targeted abuse.',
    },
    {
      description: `No hate speech or discrimination based on race, ethnicity, religion, gender, sexual orientation, or 
        disability.`,
    },
  ],
  ContentStandards: [
    {
      description: 'Do not post or stream illegal content.',
    },
    {
      description: 'Do not share content that promotes violence, terrorism, or self-harm.',
    },
    {
      description: 'Do not upload or distribute sexually explicit or pornographic material.',
    },
    {
      description:
        'Intellectual property must be respected — only share content you own or have rights to use.',
    },
  ],
  DebateEtiquette: [
    {
      description: 'Stay on topic during debates.',
    },
    {
      description: 'Allow others to speak without interruption.',
    },
    {
      description: 'Follow the debate structure and moderator instructions when applicable.',
    },
  ],
  PlatformIntegrity: [
    {
      description: 'Do not attempt to hack, disrupt, or overload the platform.',
    },
    {
      description: 'Do not create fake accounts, impersonate others, or spread misinformation.',
    },
    {
      description:
        'Do not use bots, scripts, or automation to manipulate debates, voting, or engagement.',
    },
  ],
  Enforcement: [
    {
      description: `Violations may result in content removal, temporary suspension, or permanent account 
        termination.`,
    },
    {
      description: 'Serious violations may be reported to law enforcement if required by law.',
    },
  ],
};
